const hkDistrictList = [
	{
	    zh: '香港全區',
	    szh: '香港全區',
	    en: 'All',
	    countrycode: ""
	},
    {
        zh: '中西區',
        szh: '中西区',
        en: 'Central and Western',
        countrycode: "HCW"
    },
    {
        zh: '灣仔區',
        szh: '湾仔区',
        en: 'Wan Chai',
        countrycode: "HWC"
    },
    {
        zh: '東區',
        szh: '东区',
        en: 'Eastern',
        countrycode: "HEA"
    },
    {
        zh: '南區',
        szh: '南区',
        en: 'Southern',
        countrycode: "HSO"
    },
    {
        zh: '油尖旺區',
        szh: '油尖旺区',
        en: 'Yau Tsim Mong',
        countrycode: "KYT"
    },
    {
        zh: '深水埗區',
        szh: '深水埗区',
        en: 'Sham Shui Po',
        countrycode: "KSS"
    },
    {
        zh: '九龍城區',
        szh: '九龙城区',
        en: 'Kowloon City',
        countrycode: "KKC"
    },
    {
        zh: '黃大仙區',
        szh: '黄大仙区',
        en: 'Wong Tai Sin',
        countrycode: "KWT"
    },
    {
        zh: '觀塘區',
        szh: '观塘区',
        en: 'Kwun Tong',
        countrycode: "KKT"
    },
    {
        zh: '葵青區',
        szh: '葵青区',
        en: 'Kwai Tsing',
        countrycode: "NKT"
    },
    {
        zh: '荃灣區',
        szh: '荃湾区',
        en: 'Tsuen Wan',
        countrycode: "NTW"
    },
    {
        zh: '屯門區',
        szh: '屯门区',
        en: 'Tuen Mun',
        countrycode: "NTM"
    },
    {
        zh: '元朗區',
        szh: '元朗区',
        en: 'Yuen Long',
        countrycode: "NYL"
    },
    {
        zh: '北區',
        szh: '北区',
        en: "North",
        countrycode: "NNO"
    },
    {
        zh: '大埔區',
        szh: '大埔区',
        en: 'Tai Po',
        countrycode: "NTP"
    },
    {
        zh: '沙田區',
        szh: '沙田区',
        en: 'Sha Tin',
        countrycode: "NST"
    },
    {
        zh: '西貢區',
        szh: '西贡区',
        en: 'Sai Kung',
        countrycode: "NSK"
    },
    {
        zh: '离岛區',
        szh: '離島区',
        en: "Islands",
        countrycode: "NIS"
    },
]

function getCountryObj(code){
    let obj = null

    if (null != code){
        for (let i=0; i<hkDistrictList.length; i++){
            const temp = hkDistrictList[i]

            if (temp.countrycode === code){
                obj = temp
                break
            }

        }
    }

    return obj
}

function getHKAreaObj(code){
    return getCountryObj(code)
}

export {
    hkDistrictList,
    getCountryObj,
    getHKAreaObj
}